import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Flex, theme, Typography } from 'antd'
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

const { Text } = Typography

interface TableSectionProps {
  title: string
  /** Small grey line under the title, e.g. "Preview · 5 most recent transactions". */
  caption?: string
  linkTo?: string
  linkLabel?: string
  children: ReactNode
}

/**
 * Table preview of the Revenue page (Figma 993:2513 / 1024:2660): title and
 * caption on the left, link on the right, then the table flush below - framed
 * by its own 8px-radius border, with no card around the whole block.
 */
const TableSection = ({
  title,
  caption,
  linkTo,
  linkLabel = 'View all',
  children,
}: TableSectionProps) => {
  const { token } = theme.useToken()

  return (
    <Flex vertical gap={20}>
      <Flex justify="space-between" align="center" gap={16}>
        <Flex vertical gap={4}>
          <PageTitle level={5} title={title} style={{ margin: 0 }} />
          {caption && (
            <Text style={{ fontSize: 13, color: token.colorTextTertiary }}>
              {caption}
            </Text>
          )}
        </Flex>
        {linkTo && (
          <Link to={linkTo} style={{ flex: 'none', whiteSpace: 'nowrap' }}>
            {linkLabel} →
          </Link>
        )}
      </Flex>
      <div
        style={{
          border: `1px solid ${token.colorBorderSecondary}`,
          borderRadius: 8,
          overflow: 'hidden',
          background: token.colorBgContainer,
        }}
      >
        {children}
      </div>
    </Flex>
  )
}

export default TableSection
